<ingot>
  <figure><ng-content select="[image]"></ng-content></figure>

  <div class="content"><ng-content></ng-content></div>
</ingot>
